// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1kB4Y","title":"BackImages_title__1Uj7a","images":"BackImages_images__31lFD"};